<template>

  <v-card-text>

    <v-select solo dense read-only v-model="scenarioTxt" :items="scenariosTxt" :label="$t('scenario')"
    color="onprimary" item-color="onprimary"></v-select>

    <div class="pegelsliderDivHochwasser">
      <div class="pegelslider">
        <v-slider color="onprimary" track-color="onprimary" v-model="scenarioIdx" vertical :max="3" ticks="always"
          step="1" tick-size="4">
        </v-slider>
      </div>
      <div>
        <img class="pegellatte" src="static/images/pegelslider150blau.png" style="display: inline-block;" />
        <!--<v-img class="pegellatte" src="static/images/pegelslider150.png"></v-img>-->
      </div>
      <!--
      <div class="sliderScenarioLabel">
        <table height="100%">
          <tr><td>{{ $t('topic.Hochwasser.slider3') }}</td></tr>
          <tr><td>{{ $t('topic.Hochwasser.slider2') }}</td></tr>
          <tr><td>{{ $t('topic.Hochwasser.slider1') }}</td></tr>
          <tr><td>{{ $t('topic.Hochwasser.slider0') }}</td></tr>
        </table>
      </div>
      -->
    </div>

    <!-- TODO Legende. Festes Bild oder aus Geoserver? (getLegend Request, vielleicht Componente [custom] nutzen?)-->
    <!-- TODO Opacitiy Slider anbieten? -->
    <wgu-layeropacitycontrolcustom :layer="activeLayer" v-if="activeLayer" title="Layer Deckkraft einstellen"/>

    <v-list-item v-if="showLegends && activeLayer" id="LegendHW">
      <wgu-layerlegendimagecustom :layer="activeLayer" :mapView="mapView" />
    </v-list-item>

  </v-card-text>

</template>

<script>
import { Mapable } from '../../../src/mixins/Mapable';
import LayerLegendImageCustom from './LayerLegendImageCustom.vue'
import LayerOpacityControlCustom from './LayerOpacityControlCustom.vue';
// import LayerListItem from './LayerListItem'

export default {
  name: 'wgu-layerlisthochwasser',
  components: {
    'wgu-layerlegendimagecustom': LayerLegendImageCustom,
    'wgu-layeropacitycontrolcustom': LayerOpacityControlCustom
  },
  mixins: [Mapable],
  props: {
    showLegends: { type: Boolean, required: true },
    showOpacityControls: { type: Boolean, required: true },
    layersTopicName: { type: String, required: true }
  },
  data () {
    return {
      mapView: null,
      layers: [],
      activeLayer: null,
      scenarios: ['hw_h', 'hw_m', 'hw_s', 'hw_n'], /* TODO: Szenarien aus Visible Layer? An welcher Stelle? *onMapBound? */
      scenariosTxt: [
        this.$t('topic.Hochwasser.slider0'),
        this.$t('topic.Hochwasser.slider1'),
        this.$t('topic.Hochwasser.slider2'),
        this.$t('topic.Hochwasser.slider3')
      ],
      scenarioTxt: this.$t('topic.Hochwasser.slider1'), /* TODO: Startszenarion aus Visible Layer? An welcher Stelle? *onMapBound? */
      scenarioIdx: 1 /* TODO: Startszenarion aus Visible Layer? An welcher Stelle? *onMapBound? */
    }
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound () {
      this.layers = this.map.getLayers().getArray();
      this.mapView = this.map.getView();
      this.getActiveLayer();
    },
    adjustLayerVisibility (makeThisLayerVisible) {
      this.displayedLayers.forEach(l => {
        if (l.get('lid') !== makeThisLayerVisible && l.get('lid') !== 'hw_schutz_fcl') {
          l.setVisible(false)
        } else {
          l.setVisible(true)
          this.activeLayer = l
        }
      }

      )
    },
    getActiveLayer () {
      this.displayedLayers.forEach(l => {
        if (l.getVisible() && l.get('lid') !== 'hw_schutz_fcl') {
          this.activeLayer = l;
        }
      }
      )
    },
    setSliderValue (idx) {
      this.scenario = idx
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers layers to be shown in the control.
     * Remarks: The 'displayInLayerList' attribute should default to true per convention.
     */
    displayedLayers () {
      return this.layers
        .filter(layer => layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer') && layer.get('layerGroup') === this.layersTopicName)
        .reverse();
    }
  },
  watch: {
    scenarioTxt: function (s1, s2) {
      // Kopplung Slider und Select
      this.scenarioIdx = this.scenariosTxt.indexOf(s1)
    },
    scenarioIdx: function (s1, s2) {
      // Kopplung Slider und Select
      this.scenarioTxt = this.scenariosTxt[s1]

      // Aktivierung Layer
      this.adjustLayerVisibility(this.scenarios[s1])
    }
  }
}
</script>

<style scoped>

.v-list-item {
  padding-left: 4px !important;
}

@media only screen and (max-width: 600px) {
  .v-list-item {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  #LegendHW.legendImage {
    width: 100%;
  }

}

</style>

<style>

  .pegelsliderDivHochwasser {
    display: flex;
    /* TODO height media abhängig */
  }

  .pegelsliderDivHochwasser .pegelslider {
    margin-top: 8px;  /* TODO height media abhängig */
    margin-bottom: 8px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .pegellatte {  /* TODO height media abhängig */
    height: 150px;
  }

  .sliderScenarioLabel {  /* TODO height media abhängig */
    margin: 10px 0;
  }

  .pegelsliderDivHochwasser .v-slider--vertical {
    /* TODO height media abhängig */
    min-height: 115px !important;
  }

  .pegelsliderDivHochwasser .v-slider__tick {
    background-color: #7FB0D0;
  }

  @media only screen and (max-height: 700px) {

    .pegellatte {  /* TODO height media abhängig */
    height: 100px !important;
  }

  .sliderScenarioLabel {  /* TODO height media abhängig */
    margin: 0;
  }

  .pegelsliderDivHochwasser .v-slider--vertical {
    /* TODO height media abhängig */
    min-height: 65px !important;
  }

}

</style>
